export function facebookTrackLead() {
  try {
    fbq('track', 'Lead', {
      value: 10.00,
      currency: 'USD',
    }, { eventId: sessionStorage.getItem('fb-event-id') });
  } catch (err) {
    console.error('Error tracking lead form submission for Facebook', err);
  }
}
